import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { EImportacaoType } from "../../table/EImportacaoType";
import { getImportacaoType } from "../../../utils/get-importacao-type";

@Component({
  selector: "ngx-modal-erro",
  templateUrl: "./modal-erro.component.html",
  styleUrls: ["./modal-erro.component.scss"],
})
export class ModalErroComponent implements OnInit {
  @ViewChild("erroAtivacao", { static: false })
  public erroAtivacao: ElementRef;

  @Input() motivoStatus: string;
  @Input() importacaoType: EImportacaoType;

  public importacaoName: { type: string; name: string };

  constructor(protected ref: NbDialogRef<ModalErroComponent>) {}

  ngOnInit(): void {
    if (this.erroAtivacao) {
      this.erroAtivacao.nativeElement.ownerDocument.activeElement.blur();
    }

    this.getImportacaoName();
  }

  getImportacaoName() {
    this.importacaoName = getImportacaoType(this.importacaoType);
  }

  close() {
    this.ref.close();
  }

  confirm() {
    this.ref.close(true);
  }
}
